module.exports = __webpack_public_path__ + "media/app/assets/races/goblin_female-cd4961e1884ae1dc3e677ab0c3b59636.png";